/**
 * [PORTABLE] Renders awarded onboarding badges.
 * Target path in main project: src/features/onboarding/components/BadgesStrip.tsx
 */
import { Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { OnboardingBadge } from "../types/onboarding.types";

export function BadgesStrip({ badges }: { badges: OnboardingBadge[] }) {
  const { t } = useTranslation();

  if (!badges?.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {badges.map((b, index) => (
        <span
          key={b.type || index}
          className="inline-flex items-center gap-1.5 rounded-full border border-border-primary bg-bg-tertiary/40 px-3 py-1 text-xs font-medium text-text-primary"
        >
          <Trophy className="h-3.5 w-3.5" />
          {b.type 
            ? t(`onboarding.badges.${b.type}`, { defaultValue: b.type.toString().replace('_', ' ') }) 
            : 'BADGE'}
        </span>
      ))}
    </div>
  );
}